module.exports = __webpack_public_path__ + "media/images/map-icons/icon2_selected@3x-7f96c8cb740fc606f22da8071163197e.png";